import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

export enum eChangesOptions {
  WITH_CHANGES = "עם החלפות",
  WITHOUT_CHANGES = "קו ישיר בלבד"
}

export const CHNAGES_OPTIONS: SelectOption<boolean>[] = [
  {
    label: eChangesOptions.WITHOUT_CHANGES,
    value: false,
  },
  {
    label: eChangesOptions.WITH_CHANGES,
    value: true,
  },
];
